import type { RoleWithID } from "@/models/contractBuilder";

export const getCountOfRole = (role: RoleWithID, activeRoles: RoleWithID[]) => {
  if (!role) {
    return "";
  }
  const type = role.role;
  const filtered = activeRoles.filter((r) => r.role === type);
  return filtered.findIndex((r) => r.id === role.id) + 1;
};

export const formatRoleOptions = ({ role }: RoleWithID) => `${role}`;
